import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  IconButtonSemantic_getInstanceyhbmf43a1vw3 as IconButtonSemantic_getInstance,
  NumberBadgeSemantic_getInstance2wez41hmadmon as NumberBadgeSemantic_getInstance,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atTopEnd2f4khbhwy0qa as get_atTopEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_rem14pbkv8p42gid as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  weight31wqab1913ly4 as weight,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { sidePanel1n7xwnpayabwm as sidePanel } from './dialogs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function filterMenu(_this__u8e3s4, target, onClear, content) {
  content = content === VOID ? null : content;
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, 1.0), IconButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_1 = themed(element, CompactSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Frame())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var this_2 = get_centered(element_0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (IconView())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_source_3o5lkf_k$(Companion_getInstance().filterList_1.resize_q1xpz0_k$(get_rem(1.25)));
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6(element_1);
  var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, filterMenu$lambda);
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  var tmp_2 = get_atTopEnd(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_3 = themed(shownWhen(tmp_2, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(target).activeCount_htest3_k$() > 0), NumberBadgeSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_3.willAddChild_hz2iwc_k$(element_2);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_5, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(target).activeCount_htest3_k$().toString());
  element_2.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  onClick(element, VOID, VOID, VOID, filterMenu$slambda(element, content, onClear));
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function filterChip(_this__u8e3s4, filterText, editMode, remove) {
  editMode = editMode === VOID ? null : editMode;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_0 = themed(_this__u8e3s4, ChipSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  element.set_gap_jwjroq_k$(get_rem(0.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_1 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(filterText));
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'kotlin.let' call
  var it = get_centered(element);
  var tmp_2;
  if (editMode == null) {
    tmp_2 = it;
  } else {
    tmp_2 = shownWhen(it, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(editMode));
  }
  var tmp$ret$7 = tmp_2;
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_2 = get_unpadded(tmp$ret$7);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (Button())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var icon = Companion_getInstance().close_1.resize_q1xpz0_k$(get_rem(0.75));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (IconView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_source_3o5lkf_k$(icon);
  element_2.set_description_s1386w_k$('Remove');
  element_2.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_2);
  element_1.set_action_2ds022_k$(Action('Remove Filter', VOID, VOID, VOID, VOID, VOID, filterChip$slambda(remove)));
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
var FilterChipClass;
function FilterChip() {
  if (FilterChipClass === VOID) {
    class $_0 {
      constructor(value, label, remove) {
        this.value_1 = value;
        this.label_1 = label;
        this.remove_1 = remove;
      }
      *remove_94srgz_k$($completion) {
        return yield* $(this.remove_1(this.value_1, $completion), $completion);
      }
    }
    initMetadataForClass($_0, 'FilterChip', VOID, VOID, VOID, [0]);
    FilterChipClass = $_0;
  }
  return FilterChipClass;
}
function filterMenu$lambda($this$invoke) {
  return 'Filters';
}
function filterMenu$slambda$lambda$slambda($onClear, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($onClear($completion), $completion);
    $close();
    return Unit_instance;
  }), 0);
}
function filterMenu$slambda$lambda$slambda_0($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function filterMenu$slambda($$this$button, $content, $onClear) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    sidePanel(tmp, VOID, ($this$sidePanel, close) => {
      h2($this$sidePanel, 'Filters');
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (Separator())($this$sidePanel.get_context_h02k06_k$());
      ensureOutermostElement(element);
      $this$sidePanel.willAddChild_hz2iwc_k$(element);
      element.onStartup_vrxh3i_k$();
      $this$sidePanel.addChild_2qpft2_k$(element);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = weight($this$sidePanel, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      this_0.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(true);
      var tmp0_safe_receiver = $content;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(element_0);
      element_0.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Separator())($this$sidePanel.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      $this$sidePanel.willAddChild_hz2iwc_k$(element_1);
      element_1.onStartup_vrxh3i_k$();
      $this$sidePanel.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (RowOrCol())($this$sidePanel.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      $this$sidePanel.willAddChild_hz2iwc_k$(element_2);
      element_2.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_1 = themed(element_2, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (Button())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      this_1.willAddChild_hz2iwc_k$(element_3);
      text(element_3, 'Clear filters');
      onClick(element_3, VOID, VOID, VOID, filterMenu$slambda$lambda$slambda($onClear, close));
      element_3.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_3);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_2 = weight(element_2, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (Space())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_2.willAddChild_hz2iwc_k$(element_4);
      element_4.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_4);
      // Inline function 'com.lightningkite.kiteui.views.important' call
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_3 = themed(element_2, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_4 = themed(this_3, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (Button())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      this_4.willAddChild_hz2iwc_k$(element_5);
      text(element_5, 'Apply filters');
      onClick(element_5, VOID, VOID, VOID, filterMenu$slambda$lambda$slambda_0(close));
      element_5.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_5);
      element_2.onStartup_vrxh3i_k$();
      $this$sidePanel.addChild_2qpft2_k$(element_2);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
function filterChip$slambda($remove) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $($remove($completion), $completion);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  FilterChip as FilterChiptjf5vayz5x4r,
  filterChip as filterChip1bkihjb9h4931,
  filterMenu as filterMenu2fz1h01y9a2vu,
};
//endregion

//# sourceMappingURL=filters.mjs.map
